import React, { useState } from "react";
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginTop: "-10px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "95%",
    marginBottom: "10px",
  },
  select: {
    padding: "6px 10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  chartContainer: {
    width: "100%",
    height: "400px",
    marginBottom: "20px",
  },
  tableContainer: {
    width: "100%",
    maxHeight: "70vh",
    overflowY: "auto",
    border: "1px solid #ccc",
    borderRadius: "6px",
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
    fontSize: "13px",
    minWidth: "1200px",
  },
  th: {
	borderCollapse: "collapse",
    position: "sticky",
    top: 0,
    backgroundColor: "#b7e1b0",
    zIndex: 5,
    padding: "8px",
  },
  td: {
	borderCollapse: "collapse",
    padding: "6px",
  },
};

const BiodiversityFauna = () => {
  const [selectedArea, setSelectedArea] = useState("bedegung");

  const datasets = {
    bedegung: {
      title: "Kawasan Air Terjun Bedegung",
      chartData: [
        { year: 2023, vegetasi: 89, indeks: 3.228 },
        { year: 2024, vegetasi: 97, indeks: 3.365333333 },
        { year: 2025, vegetasi: 79, indeks: 3.820573454 },
      ],
      tableDataAVIFAUNA: [
        ["1","Alap alap capung","Falconidae","Microhierax fringillarius","Least Concerned","Appendix II","Dilindungi"],
		["2","Bondol Jawa","Estrildidae","Lonchura leucogastroides","Least Concerned","Non Appendix","Tidak dilindungi"],
		["3","Bondol peking","Estrildidae","Lonchura punctulata","Least Concerned","Non Appendix","Tidak dilindungi"],
		["4","Bubut alang-alang","Cuculidae","Centropus bengalensis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["5","Bubut besar","Cuculidae","Centropus sinensis","-","Non Appendix","Tidak dilindungi"],
		["6","Burung-gereja Erasia","Passeridae","Passer montanus","-","Non Appendix","Tidak dilindungi"],
		["7","Burung madu kelapa","Nectariniidae","Anthreptes malacensis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["8","Burung madu sepah raja","Nectariniidae","Aethopyga siparaja","-","Non Appendix","Tidak dilindungi"],
		["9","Burung madu sriganti","Nectariniidae","Cinnyris ornatus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["10","Cabai bunga api","Dicaeidae","Dicaeum trigonostigma","Least Concerned","Non Appendix","Tidak dilindungi"],
		["11","Cabai merah","Dicaeidae","Dicaeum cruentatum","Least Concerned","Non Appendix","Tidak dilindungi"],
		["12","Caladi tilik","Picidae","Picoides moluccensis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["13","Caladi ulam","Picidae (+)","Dendrocopos analis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["14","Cekakak belukar","Alcedinidae","Halcyon smyrnensis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["15","Cekakak sungai","Alcedinidae","Todiramphus chloris","Least Concerned","Non Appendix","Tidak dilindungi"],
		["16","Cica kopi Melayu","Timaliidae","Pomatorhinus montanus","Vulnerable","Non Appendix","Tidak dilindungi"],
		["17","Cici padi","Cisticolidae","Cisticola juncidis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["18","Cikrak bambu","Scotocercidae","Abroscopus superciliaris","Least Concerned","Non Appendix","Tidak dilindungi"],
		["19","Cikrak polos","Phylloscopidae","Phylloscopus inornatus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["20","Cinenen belukar","Cisticolidae","Orthotomus atrogularis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["21","Cinenen kelabu","Cisticolidae","Orthotomus ruficeps","Least Concerned","Non Appendix","Tidak dilindungi"],
		["22","Cinenen merah","Cisticolidae","Orthotomus sericeus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["23","Cingcoang cokelat","Muscicapidae","Brachypteryx leucophrys","Least Concerned","Non Appendix","Tidak dilindungi"],
		["24","Cipoh jantung","Aegithinidae","Aegithina viridissima","Near Threatened","Non Appendix","Tidak dilindungi"],
		["25","Cipoh kacat","Aegithinidae","Aegithina tiphia","Least Concerned","Non Appendix","Tidak dilindungi"],
		["26","Ciung air coreng","Timaliidae","Mixornis bornensis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["27","Ciung air Melayu","Timaliidae (+)","Mixornis gularis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["28","Cucak kuning","Pycnonotidae","Rubigula dispar","Vulnerable","Non Appendix","Tidak dilindungi"],
		["29","Cucak kutilang","Pycnonotidae","Pycnonotus aurigaster","Least Concerned","Non Appendix","Tidak dilindungi"],
		["30","Delimukan zamrud","Columbidae","Chalcophaps indica","Least Concerned","Non Appendix","Tidak dilindungi"],
		["31","Elang brontok","Accipitridae","Nisaetus cirrhatus","Least Concerned","Appendix II","Dilindungi"],
		["32","Elang ular bido","Accipitridae","Spilornis cheela","Least Concerned","Appendix II","Dilindungi"],
		["33","Gagak hutan","Corvidae","Corvus enca","Least Concerned","Non Appendix","Tidak dilindungi"],
		["34","Gemak loreng","Turnicidae","Turnix suscitator","Least Concerned","Non Appendix","Tidak dilindungi"],
		["35","Jingjing batu","Vangidae (+)","Hemipus hirundinaceus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["36","Kadalan selaya","Cuculidae","Rhinortha chlorophaea","Least Concerned","Non Appendix","Tidak dilindungi"],
		["37","Kapasan kemiri","Campephagidae","Lalage nigra","Least Concerned","Non Appendix","Tidak dilindungi"],
		["38","Kapinis rumah","Apodidae","Apus nipalensis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["39","Kedasi hitam","Cuculidae","Surniculus lugubris","Least Concerned","Non Appendix","Tidak dilindungi"],
		["40","Kehicap ranting","Monarchidae ","Hypothymis azurea","Least Concerned","Non Appendix","Tidak dilindungi"],
		["41","Kekep babi","Artamidae (+)","Artamus leucorynchus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["42","Layang-layang batu","Hirundinidae","Hirundo javanica","Least Concerned","Non Appendix","Tidak dilindungi"],
		["43","Merbah belukar","Pycnonotidae","Pycnonotus plumosus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["44","Merbah cerukcuk","Pycnonotidae","Pycnonotus goiavier","Least Concerned","Non Appendix","Tidak dilindungi"],
		["45","Merbah mata-merah","Pycnonotidae","Pycnonotus brunneus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["46","Munguk beledu","Sittidae ","Sitta frontalis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["47","Munguk loreng","Sittidae","Sitta azurea","Least Concerned","Non Appendix","Tidak dilindungi"],
		["48","Paok Melayu","Pittidae","Hydrornis irena","Near threatened","Non Appendix","Dilindungi"],
		["49","Pelanduk semak","Pellorneidae","Malacocincla sepiaria","Least Concerned","Non Appendix","Tidak dilindungi"],
		["50","Pelanduk topi hitam","Pellorneidae","Pellorneum nigrocapitatum","Least Concerned","Non Appendix","Tidak dilindungi"],
		["51","Pelatuk kijang","Picidae","Micropternus brachyurus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["52","Pentis pelangi","Dicaeidae","Prionochilus percussus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["53","Pentis raja","Dicaeidae","Prionochilus maculatus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["54","Perenjak gunung","Cisticolidae (+)","Prinia superciliaris","Least Concerned","Non Appendix","Tidak dilindungi"],
		["55","Perenjak rawa","Cisticolidae","Prinia flaviventris","Least Concerned","Non Appendix","Tidak dilindungi"],
		["56","Perkutut Jawa","Columbidae","Geopelia striata","Least Concerned","Non Appendix","Tidak dilindungi"],
		["57","Pijantung kecil","Nectariniidae","Arachnothera longirostra","Least Concerned","Non Appendix","Tidak dilindungi"],
		["58","Punai gading","Columbidae","Treron vernans","Least Concerned","Non Appendix","Tidak dilindungi"],
		["59","Raja udang meninting","Alcedinidae","Alcedo meninting","Near threatened","Non Appendix","Tidak dilindungi"],
		["60","Sikatan belang","Muscicapidae","Ficedula westermanni","Least Concerned","Non Appendix","Tidak dilindungi"],
		["61","Sikatan rimba dada-cokelat","Muscicapidae","Cyornis olivaceus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["62","Srigunting hitam","Dicruridae","Dicrurus macrocercus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["63","Srigunting kelabu","Dicruridae","Dicrurus leucophaeus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["64","Takur gedang","Megalaimidae","Psilopogon chrysopogon","Least Concerned","Non Appendix","Dilindungi"],
		["65","Takur kuping hitam","Megalaimidae (+)","Psilopogon duvaucelii","Least Concerned","Non Appendix","Tidak dilindungi"],
		["66","Takur tenggeret","Megalaimidae","Psilopogon australis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["67","Takur tohtor","Megalaimidae","Psilopogon armillaris","Least Concerned","Non Appendix","Dilindungi"],
		["68","Takur ungkut-ungkut","Megalaimidae","Psilopogon haemacephalus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["69","Takur ampi Melayu","Megalaimidae","Caloramphus hayii","Near threatened","Non Appendix","Dilindungi"],
		["70","Tekukur biasa","Columbidae","Spilopelia chinensis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["71","Tepekong jambul","Hemiprocnidae","Hemiprocne longipennis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["72","Tepus pipi perak","Timaliidae","Cyanoderma melanothorax","Least Concerned","Non Appendix","Tidak dilindungi"],
		["73","Tuwur Asia","Cuculidae","Eudynamys scolopacea","Least Concerned","Non Appendix","Tidak dilindungi"],
		["74","Walet sapi","Apodidae","Collocalia esculenta","Least Concerned","Non Appendix","Tidak dilindungi"],
		["75","Wiwik kelabu","Cuculidae","Cacomantis merulinus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["76","Wiwik rimba","Cuculidae (+)","Cacomantis variolosus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["77","Wiwik uncuing","Cuculidae","Cacomantis sepulcralis","Least Concerned","Non Appendix","Tidak dilindungi"],
      ],
	  
      summaryAVIFAUNA: {
        spesies: [97],
        indeks: [3.821],
      },
	  
	  tableDataMAMALIA: [
		["1","Monyet ekor panjang","Cercopithecidae","Macaca fascicularis","Endangered","Appendix II","Tidak dilindungi"],
		["2","Simpai ","Cercopithecidae","Presbytis melalophos","Endangered","Appendix II","Dilindungi"],
		["3","Barong besar","Hipposideridae","Hipposideros diadema","Least Concerned","Non Appendix","Tidak dilindungi"],
		["4","Siamang","Hylobatidae","Symphalangus syndactylus","Endangered","Appendix II","Dilindungi"],
		["5","Cecadu pisang kecil","Pteropodidae","Macroglossus minimus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["6","Codot krawar","Pteropodidae","Cynopterus brachyotis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["7","Bajing kelapa","Sciuridae","Callosciurus notatus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["8","Musang luwak","Viverridae","Paradoxurus hermaphroditus","Least Concerned","Non Appendix","Tidak dilindungi"],
	  ],
	  
	  summaryMAMALIA: {
        spesies: [8],
        indeks: [1.941],
      },
	  
	  tableDataAMFIBI: [
		["1","Bangkong kolong","Bufonidae","Duttaphrynus melanostictus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["2","Kodok puru hutan","Bufonidae","Ingerophrynus biporcatus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["3","Katak sawah","Dicroglossidae","Fejervarya cancrivora","Least Concerned","Non Appendix","Tidak dilindungi"],
		["4","Katak tegalan","Dicroglossidae","Fejervarya limnocharis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["5","Kongkang kolam","Ranidae","Hylarana chalconota","Least Concerned","Non Appendix","Tidak dilindungi"],
		["6","Kongkang gading","Ranidae","Hylarana erythraea","Least Concerned","Non Appendix","Tidak dilindungi"],
		["7","Katak-pohon bergaris","Rhacophoridae","Polypedates leucomystax","Least Concerned","Non Appendix","Tidak dilindungi"],
	  ],
	  
	  tableDataREPTIL: [
		["1","Bunglon hutan","Agamidae","Bronchochela cristatella","Least Concerned","Non Appendix","Tidak dilindungi"],
		["2","Bunglon surai","Agamidae","Bronchochela jubata","Least Concerned","Non Appendix","Tidak dilindungi"],
		["3","Cecak terbang Sumatera","Agamidae","Draco sumatranus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["4","Ular pucuk","Colubridae","Ahaetulla prasina","Least Concerned","Non Appendix","Tidak dilindungi"],
		["5","Ular tambang","Colubridae","Dendrelaphis pictus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["6","Cecak tembok","Gekkonidae","Cosymbotus platyurus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["7","Tokek rumah","Gekkonidae","Gekko gecko","Least Concerned","Non Appendix","Tidak dilindungi"],
		["8","Cecak kayu","Gekkonidae","Hemidactylus frenatus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["9","Kadal matahari","Scincidae","Eutropis multifasciata","Least Concerned","Non Appendix","Tidak dilindungi"],
		["10","Biawak","Varanidae","Varanus salvator","Least Concerned","Non Appendix","Tidak dilindungi"],
	  ],
	  
	  summaryREPTIL: {
        spesies: [10],
        indeks: [2.624],
      },
	  
	  tableDataODONATA: [
		["1","Kilap hijau","Calopterygidae","Neurobasis chinensis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["2","Binar kecubung","Calopterygidae","Vestalis amethystina","Least Concerned","Non Appendix","Tidak dilindungi"],
		["3","Binar jelaga","Calopterygidae","Vestalis lugens","Least Concerned","Non Appendix","Tidak dilindungi"],
		["4","Permata biru sayap sempit","Chlorocyphidae","Heliocypha angusta","Least Concerned","Non Appendix","Tidak dilindungi"],
		["5","Permata hitam Snelleman","Chlorocyphidae","Melanocypha snellemanni","Least Concerned","Non Appendix","Tidak dilindungi"],
		["6","Devadatta kelam","Devadattidae","Devadatta argyoides","Least Concerned","Non Appendix","Tidak dilindungi"],
		["7","Beludru hitam biasa","Euphaeidae","Dysphaea dimidiata","Least Concerned","Non Appendix","Tidak dilindungi"],
		["8","Beludru pupus","Euphaeidae","Euphaea aspasia","Least Concerned","Non Appendix","Tidak dilindungi"],
		["9","Beludru Sunda","Euphaeidae","Euphaea variegata","Least Concerned","Non Appendix","Tidak dilindungi"],
		["10","Penggada batu","Gomphidae","Sieboldius japponicus","Least Concerned","Non Appendix","Tidak dilindungi"],
		["11","Perut terompet biasa","Libellulidae","Acisoma panorpoides","Least Concerned","Non Appendix","Tidak dilindungi"],
		["12","Coblang kecil oranye","Libellulidae","Brachythemis contaminata","Least Concerned","Non Appendix","Tidak dilindungi"],
		["13","Sibar tanah belang","Libellulidae","Diplacodes trivialis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["14","Coblang kecil","Libellulidae","Neurothemis fluctuans","Least Concerned","Non Appendix","Tidak dilindungi"],
		["15","Coblang jala lekuk","Libellulidae","Neurothemis ramburii","Least Concerned","Non Appendix","Tidak dilindungi"],
		["16","Coblang jala lurus","Libellulidae","Neurothemis terminata","Least Concerned","Non Appendix","Tidak dilindungi"],
		["17","Edokrawa pancawarna","Libellulidae","Orchithemis pulcherrima","Least Concerned","Non Appendix","Tidak dilindungi"],
		["18","Sibar perut kait","Libellulidae","Orthetrum chrysis","Least Concerned","Non Appendix","Tidak dilindungi"],
		["19","Sibar biru","Libellulidae","Orthetrum glaucum","Least Concerned","Non Appendix","Tidak dilindungi"],
		["20","Sibar biasa","Libellulidae","Orthetrum sabina","Least Concerned","Non Appendix","Tidak dilindungi"],
		["21","Sibar jingga","Libellulidae","Orthetrum testaceum","Least Concerned","Non Appendix","Tidak dilindungi"],
		["22","Kembara buana","Libellulidae","Pantala flavescens","Least Concerned","Non Appendix","Tidak dilindungi"],
		["23","Untai jarum umbai-biru","Platycnemididae","Prodasineura collaris","Least Concerned","Non Appendix","Tidak dilindungi"],
	  ],
	  
	  summaryODONATA: {
        spesies: [24],
        indeks: [2.858],
      },
	  
    },
	
	
    arboretum: {
      title: "Kawasan Arboretum Pagardewa",
      chartData: [
        { year: 2023, vegetasi: 54, indeks: 2.756 },
        { year: 2024, vegetasi: 55, indeks: 2.796 },
        { year: 2025, vegetasi: 96, indeks: 3.794 },
      ],
      
	  tableDataAVIFAUNA: [
		["1","Bondol Jawa","Estrildidae","Lonchura leucogastroides","Least Concerned","Non appendix","Tidak dilindungi"],
		["2","Bondol peking","Estrildidae","Lonchura punctulata","Least Concerned","Non appendix","Tidak dilindungi"],
		["3","Bubut alang-alang","Cuculidae","Centropus bengalensis","Least Concerned","Non appendix","Tidak dilindungi"],
		["4","Burung-gereja Erasia","Passeridae","Passer montanus","Least Concerned","Non appendix","Tidak dilindungi"],
		["5","Burung-madu kelapa","Nectariniidae","Anthreptes malacensis","Least Concerned","Non appendix","Tidak dilindungi"],
		["6","Burung-madu sepah raja","Nectariniidae (+)","Aethopyga siparaja","Least Concerned","Non appendix","Dilindungi "],
		["7","Burung-madu sriganti","Nectariniidae","Cinnyris ornatus","Least Concerned","Non appendix","Tidak dilindungi"],
		["8","Cabai bunga api","Dicaeidae","Dicaeum trigonostigma","Least Concerned","Non appendix","Tidak dilindungi"],
		["9","Cabai Jawa","Dicaeidae","Dicaeum trochileum","Least Concerned","Non appendix","Tidak dilindungi"],
		["10","Cabai merah","Dicaeidae","Dicaeum cruentatum","Least Concerned","Non appendix","Tidak dilindungi"],
		["11","Caladi tilik","Picidae","Picoides moluccensis","Least Concerned","Non appendix","Tidak dilindungi"],
		["12","Caladi ulam","Picidae (+)","Dendrocopos analis","Least Concerned","Non appendix","Tidak dilindungi"],
		["13","Cekakak belukar","Alcedinidae","Halcyon smyrnensis","Least Concerned","Non appendix","Tidak dilindungi"],
		["14","Cekakak sungai","Alcedinidae","Todiramphus chloris","Least Concerned","Non appendix","Tidak dilindungi"],
		["15","Cinenen belukar","Cisticolidae (+)","Orthotomus atrogularis","Least Concerned","Non appendix","Tidak dilindungi"],
		["16","Cinenen kelabu","Cisticolidae","Orthotomus ruficeps","Least Concerned","Non appendix","Tidak dilindungi"],
		["17","Cinenen merah","Cisticolidae (+)","Orthotomus sericeus","Least Concerned","Non appendix","Tidak dilindungi"],
		["18","Cipoh jantung","Aegithinidae (+)","Aegithina viridissima","Near threatened","Non appendix","Tidak dilindungi"],
		["19","Cipoh kacat","Aegithinidae","Aegithina tiphia","Least Concerned","Non appendix","Tidak dilindungi"],
		["20","Cucak kutilang","Pycnonotidae","Pycnonotus aurigaster","Least Concerned","Non appendix","Tidak dilindungi"],
		["21","Elang brontok","Accipitridae (+)","Nisaetus cirrhatus","Least Concerned","Appendix II","Dilindungi"],
		["22","Elang-ular bido","Accipitridae","Spilornis cheela","Least Concerned","Appendix II","Dilindungi"],
		["23","Gemak loreng","Turnicidae","Turnix suscitator","Least Concerned","Non appendix","Tidak dilindungi"],
		["24","Kacamata biasa","Zosteropidae","Zosterops palpebrosus","Least Concerned","Non appendix","Tidak dilindungi"],
		["25","Kapasan kemiri","Campephagidae","Lalage nigra","Least Concerned","Non appendix","Tidak dilindungi"],
		["26","Kapinis rumah","Apodidae","Apus nipalensis","Least Concerned","Non appendix","Tidak dilindungi"],
		["27","Kehicap ranting","Monarchidae (+)","Hypothymis azurea","Least Concerned","Non appendix","Tidak dilindungi"],
		["28","Kekep babi","Artamidae","Artamus leucorynchus","Least Concerned","Non appendix","Tidak dilindungi"],
		["29","Layang-layang batu","Hirundinidae","Hirundo javanica","Least Concerned","Non appendix","Tidak dilindungi"],
		["30","Merbah belukar","Pycnonotidae (+)","Pycnonotus plumosus","Least Concerned","Non appendix","Tidak dilindungi"],
		["31","Merbah cerukcuk","Pycnonotidae","Pycnonotus goiavier","Least Concerned","Non appendix","Tidak dilindungi"],
		["32","Pentis raja","Dicaeidae","Prionochilus maculatus","Least Concerned","Non appendix","Tidak dilindungi"],
		["33","Perenjak rawa","Cisticolidae (+)","Prinia flaviventris","Least Concerned","Non appendix","Tidak dilindungi"],
		["34","Perkutut Jawa","Columbidae","Geopelia striata","Least Concerned","Non appendix","Tidak dilindungi"],
		["35","Raja-udang meninting","Alcedinidae (+)","Alcedo meninting","Least Concerned","Non appendix","Tidak dilindungi"],
		["36","Serindit Melayu","Psittacidae (+)","Loriculus galgulus","Least Concerned","Appendix II","Dilindungi"],
		["37","Takur ungkut-ungkut","Megalaimidae","Psilopogon haemacephalus","Least Concerned","Non appendix","Tidak dilindungi"],
		["38","Tekukur biasa","Columbidae","Spilopelia chinensis","Least Concerned","Non appendix","Tidak dilindungi"],
		["39","Tepekong jambul","Hemiprocnidae (+)","Hemiprocne longipennis","Least Concerned","Non appendix","Tidak dilindungi"],
		["40","Walet sapi","Apodidae","Collocalia esculenta","Least Concerned","Non appendix","Tidak dilindungi"],
		["41","Wiwik uncuing","Cuculidae","Cacomantis sepulcralis","Least Concerned","Non appendix","Tidak dilindungi"],

      ],
      summaryAVIFAUNA: {
        spesies: [42],
        indeks: [3.213],
      },
	  
	  tableDataMAMALIA: [
		["1","Cecadu pisang kecil","Pteropodidae","Macroglossus minimus","Least Concerned","Non appendix","Tidak dilindungi"],
		["2","Codot krawar","Pteropodidae","Cynopterus brachyotis","Least Concerned","Non appendix","Tidak dilindungi"],
		["3","Bajing kelapa","Sciuridae","Callosciurus notatus","Least Concerned","Non appendix","Tidak dilindungi"],
		["4","Tikus pohon","Muridae","Rattus tiomanicus","Least Concerned","Non appendix","Tidak dilindungi"],
		["5","Tikus sawah","Muridae","Rattus argentiventer","Least Concerned","Non appendix","Tidak dilindungi"],

      ],
      summaryMAMALIA: {
        spesies: [5],
        indeks: [1.505],
      },
	  
	  tableDataHERPETOFAUNA: [
		["1","Cecak terbang Sumatera","Agamidae","Draco sumatranus","Least Concerned","Non appendix","Tidak dilindungi"],
		["2","Bangkong kolong","Bufonidae","Duttaphrynus melanostictus","Least Concerned","Non appendix","Tidak dilindungi"],
		["3","Katak tegalan","Dicroglossidae","Fejervarya limnocharis","Least Concerned","Non appendix","Tidak dilindungi"],
		["4","Cecak kayu","Gekkonidae","Hemidactylus frenatus","Least Concerned","Non appendix","Tidak dilindungi"],
		["5","Kongkang kolam","Ranidae","Hylarana chalconota","Least Concerned","Non appendix","Tidak dilindungi"],
		["6","Kongkang gading","Ranidae","Hylarana erythraea","Least Concerned","Non appendix","Tidak dilindungi"],
		["7","Kadal matahari","Scincidae","Eutropis multifasciata","Least Concerned","Non appendix","Tidak dilindungi"],
		["8","Biawak","Varanidae","Varanus salvator","","Appendix II",""],


      ],
      summaryHERPETOFAUNA: {
        spesies: [8],
        indeks: [1.79],
      },
	  
	  tableDataODONATA: [
		["1","Barongratu","Aeshnidae","Gynacantha subinterrupta","Least Concerned","Non appendix","Tidak dilindungi"],
		["2","Permata kecil sayap bening","Chlorocyphidae","Libellago hyalina","Least Concerned","Non appendix","Tidak dilindungi"],
		["3","Tekiyek hutan pita panjang","Coenagrionidae","Archibasis oscillans","Least Concerned","Non appendix","Tidak dilindungi"],
		["4","-","Coenagrionidae","Mortonagrion aborense","Least Concerned","Non appendix","Tidak dilindungi"],
		["5","-","Coenagrionidae","Pseudagrion australasiae","Least Concerned","Non appendix","Tidak dilindungi"],
		["6","Gada tombak biasa","Gomphidae","Ictinogomphus decoratus","Least Concerned","Non appendix","Tidak dilindungi"],
		["7","Sibar besi biasa","Libellulidae","Agrionoptera insignis","Least Concerned","Non appendix","Tidak dilindungi"],
		["8","Sibar kolam bercak pangkal","Libellulidae","Brachydiplax chalybea","Least Concerned","Non appendix","Tidak dilindungi"],
		["9","Coblang kecil oranye","Libellulidae","Brachythemis contaminata","Least Concerned","Non appendix","Tidak dilindungi"],
		["10","Peluncur hutan bergaris","Libellulidae","Cratilla lineata","Least Concerned","Non appendix","Tidak dilindungi"],
		["11","Perut garis merah","Libellulidae","Crocothemis servilia","Least Concerned","Non appendix","Tidak dilindungi"],
		["12","Coblang kecil","Libellulidae","Neurothemis fluctuans","Least Concerned","Non appendix","Tidak dilindungi"],
		["13","Coblang jala rapat","Libellulidae","Neurothemis fulvia","Least Concerned","Non appendix","Tidak dilindungi"],
		["14","Coblang jala-lekuk","Libellulidae","Neurothemis ramburii","Least Concerned","Non appendix","Tidak dilindungi"],
		["15","Sibar perut-kait","Libellulidae","Orthetrum chrysis","Least Concerned","Non appendix","Tidak dilindungi"],
		["16","Sibar biasa","Libellulidae","Orthetrum sabina","Least Concerned","Non appendix","Tidak dilindungi"],
		["17","Sibar jingga","Libellulidae","Orthetrum testaceum","Least Concerned","Non appendix","Tidak dilindungi"],
		["18","Kembara buana","Libellulidae","Pantala flavescens","Least Concerned","Non appendix","Tidak dilindungi"],
		["19","Sibar kelam pinggang gading","Libellulidae","Pseudothemis jorina","Least Concerned","Non appendix","Tidak dilindungi"],
		["20","Sibar merah biasa","Libellulidae","Rhodothemis rufa","Least Concerned","Non appendix","Tidak dilindungi"],
		["21","Sayap lukis safir","Libellulidae","Rhyothemis triangularis","Least Concerned","Non appendix","Tidak dilindungi"],
		["22","Peri belang Sunda","Libellulidae","Tetrathemis hyalina","Least Concerned","Non appendix","Tidak dilindungi"],
		["23","Beliung senja","Libellulidae","Tholymis tillarga","Least Concerned","Non appendix","Tidak dilindungi"],
		["24","Sibar pohon sayap bercak","Libellulidae","Tyriobapta torrida","Least Concerned","Non appendix","Tidak dilindungi"],
		["25","Semprang kolam biasa","Libellulidae","Urothemis signata","Least Concerned","Non appendix","Tidak dilindungi"],
		["26","Sambar senja putih","Libellulidae","Zyxomma obtusum","Least Concerned","Non appendix","Tidak dilindungi"],
		["27","Sambar senja perut lidi","Libellulidae","Zyxomma petiolatum","Least Concerned","Non appendix","Tidak dilindungi"],
		["28","Zamrud besar","Macromiidae","Epophthalmia sp","Least Concerned","Non appendix","Tidak dilindungi"],
		["29","Untai hantu biru","Platycnemididae","Copera vittata","Least Concerned","Non appendix","Tidak dilindungi"],
		["30","Untai jarum jingga","Platycnemididae","Prodasineura verticalis","Least Concerned","Non appendix","Tidak dilindungi"],

      ],
      summaryODONATA: {
        spesies: [30],
        indeks: [3.014],
      },
	  
    },
  };
				

  const selected = datasets[selectedArea];

  return (
    <div style={styles.wrapper} className="content-container">
      {/* 🔹 Header dengan dropdown di kiri */}
      <div style={styles.headerRow}>
        

        <h1 style={{ flex: 1, textAlign: "center", margin: 0 }}>
          Biodiversity Fauna {selected.title}
        </h1>

      </div>
	  
	  <div style={{ width: "100%", marginBottom:"5px", display: "flex", justifyContent: "flex-start" }}>
		<select
		  value={selectedArea}
		  onChange={(e) => setSelectedArea(e.target.value)}
		  style={styles.select}
		>
		  <option value="bedegung">Kawasan Air Terjun Bedegung</option>
		  <option value="arboretum">Kawasan Arboretum Pagardewa</option>
		</select>
	  </div>
      {/* 🔹 TABEL */}
	  
	  {selectedArea === "bedegung" && (
		<>
      <div style={styles.tableContainer}>
        <table border="1" className="table table-bordered" style={styles.table}>
          <thead>
            <tr>
              {[
                "No",
                "Nama Jenis",
                "Family",
                "Genus & Species",
                "Red List IUCN",
                "Appendix CITES",
                "PerMen LHK Nomor 106/2018",
              ].map((header, i) => (
                <th key={i} style={styles.th}>
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
			<tr>
				<td>A</td>
				<td colspan="6" style={{ textAlign: "left" }}>AVIFAUNA (BURUNG)</td>
			</tr>
            {selected.tableDataAVIFAUNA.map((row, index) => (
              <tr key={index}>
                {row.map((cell, i) => (
                  <td key={i} style={styles.td}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}

            {/* Ringkasan */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Jumlah Spesies</td>
              {selected.summaryAVIFAUNA.spesies.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Indeks (H')</td>
              {selected.summaryAVIFAUNA.indeks.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
			
			<tr>
				<td>B</td>
				<td colspan="6" style={{ textAlign: "left" }}>MAMALIA</td>
			</tr>
			
			{selected.tableDataMAMALIA.map((row, index) => (
              <tr key={index}>
                {row.map((cell, i) => (
                  <td key={i} style={styles.td}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}

            {/* Ringkasan */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Jumlah Spesies</td>
              {selected.summaryMAMALIA.spesies.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Indeks (H')</td>
              {selected.summaryMAMALIA.indeks.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
			
			<tr>
				<td>C</td>
				<td colspan="6" style={{ textAlign: "left" }}>AMFIBI</td>
			</tr>
			
			{selected.tableDataAMFIBI.map((row, index) => (
              <tr key={index}>
                {row.map((cell, i) => (
                  <td key={i} style={styles.td}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
			
			<tr>
				<td>D</td>
				<td colspan="6" style={{ textAlign: "left" }}>REPTIL</td>
			</tr>
			
			{selected.tableDataREPTIL.map((row, index) => (
              <tr key={index}>
                {row.map((cell, i) => (
                  <td key={i} style={styles.td}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}

            {/* Ringkasan */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Jumlah Spesies</td>
              {selected.summaryREPTIL.spesies.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Indeks (H')</td>
              {selected.summaryREPTIL.indeks.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
			
			<tr>
				<td>E</td>
				<td colspan="6" style={{ textAlign: "left" }}>ODONATA</td>
			</tr>
			
			{selected.tableDataODONATA.map((row, index) => (
              <tr key={index}>
                {row.map((cell, i) => (
                  <td key={i} style={styles.td}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}

            {/* Ringkasan */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Jumlah Spesies</td>
              {selected.summaryODONATA.spesies.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Indeks (H')</td>
              {selected.summaryODONATA.indeks.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
			
          </tbody>
        </table>
      </div>
	  

      {/* 🔹 GRAFIK */}
      <div style={styles.chartContainer}>
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart
            data={selected.chartData}
            margin={{ top: 20, right: 40, left: 10, bottom: 20 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
            <XAxis dataKey="year" />

            <YAxis
              yAxisId="left"
              orientation="left"
              label={{
                value: "Indeks Kehati (H')",
                angle: -90,
                position: "insideLeft",
                offset: 10,
              }}
              domain={[
                (dataMin) => Math.floor((dataMin - 0.5) * 10) / 10,
                (dataMax) => Math.ceil((dataMax + 0.1) * 10) / 10,
              ]}
              tickFormatter={(val) => val.toFixed(1)}
            />

            <YAxis
              yAxisId="right"
              orientation="right"
              label={{
                value: "Jumlah Spesies",
                angle: -90,
                position: "insideRight",
                offset: 10,
              }}
            />

            <Tooltip />
            <Legend verticalAlign="top" height={36} />
            <Bar
              yAxisId="right"
              dataKey="vegetasi"
              name="Jumlah Spesies Avifauna"
              fill="#82b6f7"
              barSize={40}
              radius={[4, 4, 0, 0]}
            />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="indeks"
              name="Indeks Kehati (H')"
              stroke="#333"
              strokeWidth={2}
              dot={{ fill: "#333", r: 4 }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
	  </>
	  )}
	  
	  {selectedArea === "arboretum" && (
		<>
      <div style={styles.tableContainer}>
        <table border="1" className="table table-bordered" style={styles.table}>
          <thead>
            <tr>
              {[
                "No",
                "Nama Jenis",
                "Family",
                "Genus & Species",
                "Red List IUCN",
                "Appendix CITES",
                "PerMen LHK Nomor 106/2018",
              ].map((header, i) => (
                <th key={i} style={styles.th}>
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
			<tr>
				<td>A</td>
				<td colspan="6" style={{ textAlign: "left" }}>AVIFAUNA (BURUNG)</td>
			</tr>
            {selected.tableDataAVIFAUNA.map((row, index) => (
              <tr key={index}>
                {row.map((cell, i) => (
                  <td key={i} style={styles.td}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}

            {/* Ringkasan */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Jumlah Spesies</td>
              {selected.summaryAVIFAUNA.spesies.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Indeks (H')</td>
              {selected.summaryAVIFAUNA.indeks.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
			
			<tr>
				<td>B</td>
				<td colspan="6" style={{ textAlign: "left" }}>MAMALIA</td>
			</tr>
			
			{selected.tableDataMAMALIA.map((row, index) => (
              <tr key={index}>
                {row.map((cell, i) => (
                  <td key={i} style={styles.td}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}

            {/* Ringkasan */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Jumlah Spesies</td>
              {selected.summaryMAMALIA.spesies.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Indeks (H')</td>
              {selected.summaryMAMALIA.indeks.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
			
			<tr>
				<td>C</td>
				<td colspan="6" style={{ textAlign: "left" }}>HERPETOFAUNA</td>
			</tr>
			
			{selected.tableDataHERPETOFAUNA.map((row, index) => (
              <tr key={index}>
                {row.map((cell, i) => (
                  <td key={i} style={styles.td}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
			
			{/* Ringkasan */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Jumlah Spesies</td>
              {selected.summaryHERPETOFAUNA.spesies.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Indeks (H')</td>
              {selected.summaryHERPETOFAUNA.indeks.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
			
			<tr>
				<td>D</td>
				<td colspan="6" style={{ textAlign: "left" }}>ODONATA</td>
			</tr>
			
			{selected.tableDataODONATA.map((row, index) => (
              <tr key={index}>
                {row.map((cell, i) => (
                  <td key={i} style={styles.td}>
                    {cell}
                  </td>
                ))}
              </tr>
            ))}

            {/* Ringkasan */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Jumlah Spesies</td>
              {selected.summaryODONATA.spesies.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
            <tr style={{ fontWeight: "bold", backgroundColor: "#e8f5e9" }}>
              <td colSpan="2">Indeks (H')</td>
              {selected.summaryODONATA.indeks.map((v, i) => (
                <td colspan="5" key={i}>{v}</td>
              ))}
            </tr>
			
          </tbody>
        </table>
      </div>
	  
	  </>
	  )}
	  
    </div>
  );
};

export default BiodiversityFauna;
